export class ViewPublishedNotice{
    publishedNoticesId: number;
    userTypeId: number;
    userTypeName: string;
    userTypeNameEn: string;

}